<template>
  <ul
    v-if="searchResultsArray.length > 0"
    class="box-wrapper"
    :style="{ width: width }"
    role="listbox"
  >
    <li
      v-if="comboBoxType === 'searchHistory'"
      class="recently-viewed-header"
    >
      <div class="medium">
        Recently Viewed
      </div>
      <button
        class="clear link-sm"
        @click="clearSearchResults"
      >
        Clear All
      </button>
    </li>
    <li
      v-for="(result, i) in searchResultsArray"
      :key="result"
      class="menu-link-body"
      role="option"
      :aria-selected="i === selectedIndex"
      @keydown.enter="onItemSelection(i, result)"
      @click="onItemSelection(i, result)"
    >
      <template
        v-if="comboBoxType === 'location'"
        tabindex="0"
      >
        <span
          v-for="(searchHighlight,index) in getSearchHighlights(result.description, result.matched_substrings)"
          :key="index"
          :class="{ 'heavy': searchHighlight.highlight }"
        >
          {{ searchHighlight.text }}
        </span>
      </template>
      <template v-else>
        <a
          class="recently-viewed-links"
          target="_self"
          :href="result.url"
        >{{ result.description }}</a>
      </template>
    </li>
  </ul>
</template>
<script setup>
import {
  ref, watch,
} from 'vue';

const props = defineProps({
  data: {
    type: Array,
    default: () => [],
  },
  comboBoxType: {
    type: String,
    default: undefined,
    validator: (val) => ['location', 'searchHistory'].includes(val),
  },
  width: {
    type: String,
    default: '300px',
  },
});
const emits = defineEmits(['selectedResult', 'clearSearchResults']);

const searchResultsArray = ref(props.data);

const selectedIndex = ref(-1);

watch(() => props.data,
  (newValue) => {
    searchResultsArray.value = [...newValue];
    selectedIndex.value = -1;
  },
  {
    deep: true,
  });
const onItemSelection = (index, selectedResult) => {
  selectedIndex.value = index;
  emits('selectedResult', selectedResult);
};
const clearSearchResults = () => {
  searchResultsArray.value = [];
  emits('clearSearchResults');
};

const getSearchHighlights = (addDescription, matchedSubstrings) => {
  if (!matchedSubstrings) {
    return [{ addDescription, highlight: false }];
  }
  let currentIndex = 0;
  const result = [];
  matchedSubstrings.forEach((matchedSubstring, i) => {
    const { length, offset } = matchedSubstring;
    if (currentIndex < offset) {
      result.push({ text: addDescription.slice(currentIndex, offset), highlight: false });
    }
    result.push({ text: addDescription.slice(offset, offset + length), highlight: true });
    currentIndex = offset + length;

    if ((i === matchedSubstrings.length - 1) && currentIndex < addDescription.length) {
      result.push({ text: addDescription.slice(currentIndex), highlight: false });
    }
  });
  return result;
};

</script>
<style lang="scss" scoped>
 @import "@core/csg/src/scss/typography/typography-mixins.scss";

  ul.box-wrapper {
    list-style-type: none;
    height: auto;
    padding: rem-calc(24);
    border: 1px solid $gray-1-color;
    background: $white;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.10);
    margin: rem-calc(8 0 0 0);

    li:not(:last-child) {
      margin-bottom: rem-calc(10);
    }
    //documentation classes are overriding
     .recently-viewed-links{
    @include body(regular);

    }
    .recently-viewed-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: rem-calc(10);
    }
    .clear {
      color: $gray-1-color;
    }

  }
</style>
<style lang="scss" scoped brand="mcom">
.box-wrapper {
  border-radius: 5px;
}
</style>
